import React, { useState } from "react";
import { useMutation } from "@apollo/client";
import Toast from "utils/Alert/Toast/Toast";
import { getError } from "utils/helpers";
import Modal from "utils/Modal/Modal";
import SuccessState from "utils/Modal/Response/SuccessState";
import RemoveCardForm from "./RemoveCardForm/RemoveCardForm";
import ConfirmFundOTP from "../ConfirmFundOTP/ConfirmFundOTP";
import { DELETE_SETTLEMENT_ACCOUNT } from "api/mutations/account";
import { ERROR } from "../../../../constants";

const RemoveCardModal = ({ toggle, account_number }) => {
	const [currentStep, setcurrentStep] = useState(1);
	const [otp, setOtp] = useState();
	const [loading, setLoading] = useState(false);
	const [errorMsg, setErrorMsg] = useState("");

	const nextStep = () => setcurrentStep((prev) => prev + 1);

	const [deleteAccount] = useMutation(DELETE_SETTLEMENT_ACCOUNT, {
		context: { headers: { otp } },
		onCompleted: () => {
			setLoading(false);
			nextStep();
		},
		onError: (error) => {
			setLoading(false);
			setErrorMsg(getError(error));
		},
	});

	const handleToggle = () => {
		setcurrentStep(1);
		toggle();
	};

	const refresh = () => {
		handleToggle();
		window.location.reload(true);
	};

	const handleSubmit = () => {
		setLoading(true);
		setErrorMsg();
		deleteAccount({ variables: { account_number } });
	};

	const render = () => {
		switch (currentStep) {
			case 1:
			default:
				return (
					<RemoveCardForm
						toggle={handleToggle}
						setErrorMsg={setErrorMsg}
						nextStep={nextStep}
					/>
				);

			case 2:
				return (
					<ConfirmFundOTP
						otp={otp}
						setOtp={setOtp}
						loading={loading}
						nextStep={handleSubmit}
						toggle={handleToggle}
					/>
				);

			case 3:
				return (
					<SuccessState
						btnText="Done"
						msg="Account Removed Successfully"
						toggle={refresh}
					/>
				);
		}
	};
	return (
		<>
			<Toast msg={errorMsg} variant={ERROR} />
			<Modal show={true}>{render()}</Modal>
		</>
	);
};

export default RemoveCardModal;
